import { render, staticRenderFns } from "./product_phone_balance_zfb.vue?vue&type=template&id=04efb17f&scoped=true"
import script from "./product_phone_balance_zfb.vue?vue&type=script&lang=js"
export * from "./product_phone_balance_zfb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04efb17f",
  null
  
)

export default component.exports